// extracted by mini-css-extract-plugin
var _1 = "code--rMbf0jq";
var _2 = "code-box--t9YbTDW";
var _3 = "hide-code--sEX7kR8";
var _4 = "hide-qr--dXHJvII";
var _5 = "show-code--A3VNxZH";
var _6 = "show-qr--hEX8JXH";
export { _1 as "code", _2 as "codeBox", _3 as "hideCode", _4 as "hideQr", _5 as "showCode", _6 as "showQr" }
